
  import { Component, Mixins, Prop } from "vue-property-decorator";
  import DashboardMixin from "@/views/dashboard/dashboard.mixin";
  import moment from "moment";
    
  @Component
  export default class AssessmentHistory extends Mixins(DashboardMixin) {
    @Prop() assessmentHistoryShow!: boolean;
    @Prop() type!: number;
  
    loading = false;
  
    counter = 0;
  
    async mounted() {
      this.loading = true;
      await this.fetchData();
      this.loading = false;
    }
  
    async fetchData() {
      const fetch = [
        this.$store.dispatch("Dashboard/fetchAssessmentHistory", {
          participantId: this.selectedPatientSummary.participantId, 
          clientId: this.selectedClientDDL.value,
          type: this.type,
          timezone: this.selectedClient.timezone
        })
      ];
      await Promise.all(fetch);
    }

    assessmentDate(date: string) {
      if (!date || date.trim() === "") {
        return "";
      }
      return moment(date).format("MM/DD/YYYY hh:mm:ss");
    }
  
    closeModal() {
      this.$emit('update:assessmentHistoryShow', false);
    }
  }
  